import { Injectable, inject } from '@angular/core';
import { selectIsLoggedIn } from '@arc/arc-shared-frontend';
import { Store, select } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RefreshService {

  constructor() { }

  public isLoggedIn$ = inject(Store).pipe(
    select(selectIsLoggedIn)
  );
  
  public isBypass$ = new BehaviorSubject<boolean>(false);
}
